import { DeliveryModes, PractitionerTypes, FacilityTypes } from './schema'

export const telehealthVirtualCareServices = [
  {
    serviceId: 'TELE_001',
    serviceName: 'Virtual Consultation',
    category: 'Telehealth / Virtual Care',
    specialty: null,
    subCategory: 'Virtual Consultations',
    description: 'Remote medical consultation via video call',
    cost: 280,
    durationMinutes: 30,
    deliveryModes: [DeliveryModes.VIRTUAL],
    requiredPractitionerType: PractitionerTypes.GP,
    status: 'active',
    billingCode: 'TELE_CONSULT',
    billableItems: [],
    facilityTypes: [FacilityTypes.CLINIC, FacilityTypes.VIRTUAL_CLINIC],
    customisable: true,
    tags: ['telehealth', 'virtual', 'video call'],
    displayOrder: 1
  },
  {
    serviceId: 'TELE_002',
    serviceName: 'Remote Chronic Care Management',
    category: 'Telehealth / Virtual Care',
    specialty: null,
    subCategory: 'Chronic Care',
    description: 'Virtual management of chronic conditions with remote monitoring',
    cost: 350,
    durationMinutes: 45,
    deliveryModes: [DeliveryModes.VIRTUAL],
    requiredPractitionerType: PractitionerTypes.GP,
    status: 'active',
    billingCode: 'TELE_CHRONIC',
    billableItems: [],
    facilityTypes: [FacilityTypes.CLINIC, FacilityTypes.VIRTUAL_CLINIC],
    customisable: true,
    tags: ['telehealth', 'chronic care', 'monitoring'],
    displayOrder: 2
  },
  {
    serviceId: 'TELE_003',
    serviceName: 'Virtual Mental Health Session',
    category: 'Telehealth / Virtual Care',
    specialty: 'Psychology',
    subCategory: 'Mental Health',
    description: 'Remote counseling and mental health support session',
    cost: 400,
    durationMinutes: 50,
    deliveryModes: [DeliveryModes.VIRTUAL],
    requiredPractitionerType: PractitionerTypes.ALLIED_HEALTH,
    status: 'active',
    billingCode: 'TELE_MENTAL',
    billableItems: [],
    facilityTypes: [FacilityTypes.CLINIC, FacilityTypes.VIRTUAL_CLINIC, FacilityTypes.WELLNESS_CENTER],
    customisable: true,
    tags: ['telehealth', 'mental health', 'counseling'],
    displayOrder: 3
  },
  {
    serviceId: 'TELE_004',
    serviceName: 'Remote Prescription Review',
    category: 'Telehealth / Virtual Care',
    specialty: null,
    subCategory: 'Medication Management',
    description: 'Virtual review and management of patient medications',
    cost: 180,
    durationMinutes: 20,
    deliveryModes: [DeliveryModes.VIRTUAL],
    requiredPractitionerType: PractitionerTypes.PHARMACIST,
    status: 'active',
    billingCode: 'TELE_SCRIPT',
    billableItems: [],
    facilityTypes: [FacilityTypes.CLINIC, FacilityTypes.PHARMACY, FacilityTypes.VIRTUAL_CLINIC],
    customisable: true,
    tags: ['telehealth', 'prescription', 'medication review'],
    displayOrder: 4
  },
  {
    serviceId: 'TELE_005',
    serviceName: 'Virtual Follow-up Consultation',
    category: 'Telehealth / Virtual Care',
    specialty: null,
    subCategory: 'Follow-up Care',
    description: 'Remote follow-up consultation after treatment or procedure',
    cost: 220,
    durationMinutes: 25,
    deliveryModes: [DeliveryModes.VIRTUAL],
    requiredPractitionerType: PractitionerTypes.GP,
    status: 'active',
    billingCode: 'TELE_FOLLOWUP',
    billableItems: [],
    facilityTypes: [FacilityTypes.CLINIC, FacilityTypes.VIRTUAL_CLINIC],
    customisable: true,
    tags: ['telehealth', 'follow-up', 'virtual'],
    displayOrder: 5
  },
  {
    serviceId: 'TELE_006',
    serviceName: 'Remote Diabetic Monitoring',
    category: 'Telehealth / Virtual Care',
    specialty: 'Endocrinology',
    subCategory: 'Diabetes Care',
    description: 'Virtual diabetes management with remote glucose monitoring',
    cost: 320,
    durationMinutes: 35,
    deliveryModes: [DeliveryModes.VIRTUAL],
    requiredPractitionerType: PractitionerTypes.GP,
    status: 'active',
    billingCode: 'TELE_DIABETES',
    billableItems: [],
    facilityTypes: [FacilityTypes.CLINIC, FacilityTypes.VIRTUAL_CLINIC],
    customisable: true,
    tags: ['telehealth', 'diabetes', 'monitoring'],
    displayOrder: 6
  }
]

export default telehealthVirtualCareServices
